import Vue      from 'vue';
import App      from './App.vue';
import router   from './router';
import store    from './store';
import axios    from '@/services/axios';

import './registerServiceWorker';

import Vuetify from 'vuetify'

Vue.use(Vuetify, {
  theme: {
    // primary: '#9c27b0',
    primary: '#009688',
    accent: '#ce93d8',
    secondary: '#424242',
    info: '#0D47A1',
    warning: '#ffb300',
    error: '#B71C1C',
    success: '#2E7D32'
  }
})



import 'vuetify/dist/vuetify.min.css'


import AppLayout from '@/components/layout/AppLayout'
Vue.component('app-layout', AppLayout);


Vue.config.productionTip = false;

store.subscribe((mutation, state) => {
  localStorage.setItem('store', JSON.stringify(state))
})

new Vue({
  router,
  store,
  render: h => h(App),
  beforeCreate() {
    this.$store.commit('INITIALISE_STORE');
    // this.$store.dispatch('getPlans');
  }
}).$mount('#app');
